import L from 'leaflet'
import { isAnimal, isIceAge } from './FeatureFilters'

function getIcon (name = 'generic', zoom = 6) {
  return L.icon({
    iconUrl: `${process.env.BASE_URL}icons/${name.toLowerCase()}.svg`,
    iconSize: [zoom * 10, zoom * 10], // size of the icon
    iconAnchor: [30, 20], // point of the icon which will correspond to marker's location
    popupAnchor: [-3, -76] // point from which the popup should open relative to the iconAnchor
  })
}

export default {
  iceEdge: {
    filter: isIceAge,
    options: () => ({ color: 'blue', radius: 3, opacity: 0.2, fillOpacity: 0.2, weight: 2, dashArray: '2,8' })
  },
  hunt: {
    filter: isAnimal,
    options: (zoom) => {
      return {
        pointToLayer: (feature, latLng) => {
          return new L.Marker(latLng, { icon: getIcon(feature.properties.icon || feature.properties.Icon || 'generic', zoom) })
        }
      }
    }
  },
  highlight: {
    options: () => {
      const pointToLayer = (feature, latLng) => {
        return new L.Marker(latLng, { icon: getIcon('highlight', 4) })
      }
      const onEachFeature = (feature, layer) => {
        const nameIn = layer.feature.properties['Name IN'] || ''
        const nameRn = layer.feature.properties['Name RN'] || ''
        if (feature.geometry.type === 'Polygon') {
          layer.bindTooltip(
            `<div class="polygon-labels lang-in"><div class="polygon-label">${nameIn}</div><div class="polygon-label lang-en">${nameRn}</div></div>`,
            { permanent: true, direction: 'bottom' }
          )
        }
      }
      const style = feature => ({
        color: feature.geometry.type === 'Polygon' ? '#9a6969' : '#FF7575',
        opacity: 1,
        fillColor: '#9a6969',
        fillOpacity: 0.1,
        weight: feature.geometry.type === 'Polygon' ? 1 : 3
      })

      return {
        pointToLayer,
        style,
        onEachFeature
      }
    }

  }
}
